/**
 * useApi Hook
 * Provides API client with authentication
 */

import axios, { AxiosInstance } from 'axios';
import { useMemo } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api/v1';

export const useApi = (): AxiosInstance => {
  const token = localStorage.getItem('authToken');

  const api = useMemo(() => {
    const instance = axios.create({
      baseURL: API_BASE_URL,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Add auth token to requests
    instance.interceptors.request.use(
      (config) => {
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    // Handle response errors
    instance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          // Token expired or invalid - logout user
          window.location.href = '/login';
        }
        return Promise.reject(error);
      }
    );

    return instance;
  }, [token]);

  return api;
};